import { apiClient } from '../../../client'

export function getSpeech(toteId: string): Promise<Blob> {
  return apiClient
    .post(`v1/t/speech/${toteId}`, {
      json: { engagingURL: window.location.href }
    })
    .blob()
}
